<template>
    <div :class="{ flex: !toggler.isOpen() }">
        <div>姓名</div>
        <div>
            <div class="editable" v-if="!toggler.isOpen()">
                <span>{{ props.value }}</span>
                <button @click="open" type="button">
                    <img alt="" class="w:20 h:20" src="image/icon_pen.svg" />
                </button>
            </div>
            <div class="{mt:8}@<md" v-else>
                <div>
                    <input class="form-control" :disabled="errors.name" ref="input" type="text" v-model.trim="form.name" />
                    <div class="info-msg" v-if="errors.name">
                        您的姓名已修改過一次，無法再次變更，請 <span class="font-weight:700">聯絡客服 (02)8787-1111 #8</span>
                    </div>
                    <div class="info-msg" v-else>
                        姓名僅可自行變更一次，請輸入您的真實姓名
                    </div>
                </div>
                <div class="t:right {ml:8}>button+button">
                    <button class="btn btn-sm btn-link" @click="close" type="button">取消</button>
                    <button class="btn btn-sm bg:#EEF3FB! color:#4776B4!" @click="save()" :disabled="!available_name" type="button">儲存</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    let submited = false;

    const available_name = computed(() => form.value.name && form.value.name !== props.value && !errors.value.name);

    const errors = ref({});

    const form = ref({});

    const input = ref();

    const props = defineProps({
        value: { required: true, type: String }
    });

    const toggler = ToggleStore().toggler("profile_name");

    const close = () => {
        if (available_name.value) {
            emit("cancel", () => toggler.close());
        } else {
            toggler.close();
        }
    };

    const emit = defineEmits(["cancel", "error", "login", "update"]);

    const open = () => {
        if (submited) {
            return;
        }
        submited = true;
        api("api/member/history", { type: "name" }, { prevent: true }).done((res) => {
            form.value.name = props.value;
            errors.value.name = res.data?.length;
            toggler.open();
            setTimeout(() => input.value.focus());
        }).always(() => {
            submited = false;
        });
    };

    const save = (password) => {
        if (submited) {
            return;
        }
        submited = true;
        api("api/member/save-name", { name: form.value.name, password }, { prevent: true }).done((res) => {
            if (res.success) {
                emit("update", form.value.name);
                toggler.close();
            } else if (res.error === "error.permission-denied") {
                emit("login", save);
            } else {
                emit("error", res.message);
            }
        }).always(() => {
            submited = false;
        });
    };
</script>
